import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Cookies from 'js-cookie';

import { COOKIE_KEY_CHAT_COMPANY_ID } from '../../const/AppConst';

import Expired from './pages/Expired';
import QvExpired from './pages/qv/QvExpired';
import DaishinExpired from './pages/daishin/DaishinExpired';
import HyundairsExpired from './pages/hyundairs/HyundairsExpired';

@observer
class ExpiredRouter extends Component {
  render() {
    const chatCompID = Cookies.get(COOKIE_KEY_CHAT_COMPANY_ID);

    if (chatCompID === '15') return <QvExpired {...this.props} />;

    if (chatCompID === '17') return <DaishinExpired {...this.props} />;

    if (chatCompID === '35') return <HyundairsExpired {...this.props} />;

    return <Expired {...this.props} />;
  }
}

export default ExpiredRouter;
